var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import styles from './styles.module.scss';
import { Uploader, Button, InputSelect, InputTextBox, InputText, Alert } from 'template/lib';
var Create = function () {
    var _a;
    var _b = useState([]), companiesToSelect = _b[0], setCompaniesToSelect = _b[1];
    var _c = useState([]), usersToSelect = _c[0], setUsersToSelect = _c[1];
    var _d = useState([]), software = _d[0], setSoftware = _d[1];
    var _e = useState([]), applications = _e[0], setApplications = _e[1];
    var _f = useState(''), softwareId = _f[0], setSoftwareId = _f[1];
    var _g = useState(0), applicationId = _g[0], setApplicationId = _g[1];
    var _h = useState([]), helpType = _h[0], setHelpType = _h[1];
    var _j = useState([]), photos = _j[0], setPhotos = _j[1];
    var _k = useState(false), hasImg = _k[0], setHasImg = _k[1];
    var _l = useState('0'), companyId = _l[0], setCompanyId = _l[1];
    var _m = useAuth(), login = _m.login, handleLogout = _m.handleLogout;
    var setTitle = useTitle().setTitle;
    var _o = useState(false), isSubmitting = _o[0], setIsSubmitting = _o[1];
    var _p = useState(''), errorMessage = _p[0], setErrorMessage = _p[1];
    var _q = useState(false), desableted = _q[0], setDesableted = _q[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        api.get('/helps/validationHelp', config).then(function (response) {
            if (response.data.mensage !== "") {
                setErrorMessage(response.data.mensage);
                setDesableted(true);
            }
        });
    }, []);
    useEffect(function () {
        setTitle('Novo Chamado');
        if (login && Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
            handleLogout();
            history.push('/');
        }
        if (!login) {
            history.push('/');
        }
        api.get('/helps/softwares', config).then(function (response) {
            setSoftware(response.data);
        });
        if (softwareId) {
            api.get("/helps/softwares/" + softwareId + "/applications", config).then(function (response) {
                setApplications(response.data);
            });
        }
        if ((login === null || login === void 0 ? void 0 : login.role) === 'Administrator' || (login === null || login === void 0 ? void 0 : login.role) === 'Help' || (login === null || login === void 0 ? void 0 : login.role) === 'HelpCS' || (login === null || login === void 0 ? void 0 : login.role) === 'HelpAdmin') {
            api.get('supports/helpTypes', config).then(function (response) {
                setHelpType(response.data);
            });
            api.get('/companies/active', config).then(function (response) {
                setCompaniesToSelect(response.data);
            });
            if (companyId !== '0') {
                api.get("/companies/" + companyId + "/userOptions", config).then(function (response) {
                    setUsersToSelect(response.data);
                });
            }
        }
    }, [softwareId, companyId]);
    var companies = {
        label: 'Empresa',
        options: companiesToSelect
    };
    var type = {
        label: 'Tipo de Chamado',
        options: helpType
    };
    var softweres = {
        label: 'Software',
        options: software
    };
    var aplication = {
        label: 'Aplicação',
        options: applications ? applications : []
    };
    var users = {
        label: 'Usuário',
        options: usersToSelect ? usersToSelect : []
    };
    var columns = 1;
    var history = useHistory();
    var helpSchema = Yup.object().shape({
        applicationId: Yup.string()
            .required('Por favor, informe uma aplicação.'),
        specification: Yup.string()
            .required('Por favor, informe uma descrição.'),
        courseName: Yup.string().when('applicationId', {
            is: function (applicationId) { var _a; return ((_a = applications.find(function (app) { return app.id == applicationId; })) === null || _a === void 0 ? void 0 : _a.name.toLowerCase()) === 'liberação de cursos'; },
            then: Yup.string().required('Por favor, informe o nome do curso.'),
            otherwise: Yup.string().notRequired()
        }),
    });
    var helpSchemaAdmin = Yup.object().shape({
        applicationId: Yup.string()
            .required('Por favor, informe uma aplicação.'),
        specification: Yup.string()
            .required('Por favor, informe uma descrição.'),
        requestUserId: Yup.string()
            .required('Por favor, informe um usuário.'),
        TypeId: Yup.string()
            .required('Por favor, informe um tipo.'),
    });
    var formik = useFormik({
        initialValues: {
            company: companyId,
            requestUserId: '',
            softwareID: '',
            applicationId: '',
            specification: '',
            TypeId: '',
            anyDeskAddress: '',
            courseName: ''
        },
        validationSchema: (login === null || login === void 0 ? void 0 : login.role) === 'Help' || (login === null || login === void 0 ? void 0 : login.role) === 'HelpCS' || (login === null || login === void 0 ? void 0 : login.role) === 'HelpAdmin' || (login === null || login === void 0 ? void 0 : login.role) === 'Administrator' ? helpSchemaAdmin : helpSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var typeId, id_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        typeId = values.TypeId == '' ? 0 : values.TypeId;
                        if (isSubmitting)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setErrorMessage('');
                        setIsSubmitting(true);
                        return [4 /*yield*/, api.post('/helps', __assign(__assign({}, values), { company: companyId, softwareID: softwareId, TypeId: typeId }), config).then(function (response) { return id_1 = response.data; }).then(function () {
                                if (hasImg) {
                                    var addImg = function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var data;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    data = new FormData();
                                                    return [4 /*yield*/, photos.uploadedFiles[0].map(function (file) {
                                                            if (!file.error) {
                                                                return data.append('images', file.file);
                                                            }
                                                            else {
                                                                console.log(file.error);
                                                            }
                                                        })];
                                                case 1:
                                                    _a.sent();
                                                    return [4 /*yield*/, api.post("helps/" + id_1 + "/images", data, {
                                                            headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) },
                                                        }).then(function () { return history.push('profile'); })];
                                                case 2:
                                                    _a.sent();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); };
                                    addImg();
                                }
                                else {
                                    history.push('profile');
                                }
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        if (!login || Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
                            handleLogout();
                            history.push('/');
                        }
                        if (err_1.response.data.message) {
                            setErrorMessage(err_1.response.data.message);
                        }
                        else if (err_1.response.data.detail) {
                            setErrorMessage(err_1.response.data.detail);
                        }
                        else {
                            alert('erro');
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsSubmitting(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); },
    });
    return (
    //<div className='overflow-auto h-screen'>
    _jsx("div", __assign({ className: styles.container }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: styles.grid }, { children: _jsxs("div", __assign({ className: styles.inputs }, { children: [((login === null || login === void 0 ? void 0 : login.role) === 'Administrator' || (login === null || login === void 0 ? void 0 : login.role) === 'Help' || (login === null || login === void 0 ? void 0 : login.role) === 'HelpCS' || (login === null || login === void 0 ? void 0 : login.role) === 'HelpAdmin') &&
                                _jsxs(_Fragment, { children: [_jsx(InputSelect, { name: 'company', value: companyId, values: companies, valueMember: 'id', displayMember: 'name', onChange: function (e) { return setCompanyId(e.target.value); } }, void 0), _jsx(InputSelect, { onChange: formik.handleChange, value: formik.values.requestUserId, name: 'requestUserId', values: users, valueMember: 'id', displayMember: 'name' }, void 0), formik.errors.requestUserId && formik.touched.requestUserId && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.requestUserId }), void 0), _jsx(InputSelect, { onChange: formik.handleChange, value: formik.values.TypeId, name: 'TypeId', values: type, valueMember: 'id', displayMember: 'name' }, void 0), formik.errors.TypeId && formik.touched.TypeId && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.TypeId }), void 0)] }, void 0), _jsx(InputSelect, { onChange: function (e) { return setSoftwareId(e.target.value); }, name: 'softwareID', value: softwareId, values: softweres, valueMember: 'id', displayMember: 'name' }, void 0), _jsx(InputSelect, { onChange: function (e) { formik.handleChange(e); setApplicationId(e.target.value); }, value: formik.values.applicationId, name: 'applicationId', values: aplication, valueMember: 'id', displayMember: 'name' }, void 0), formik.errors.applicationId && formik.touched.applicationId && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.applicationId }), void 0), ((login === null || login === void 0 ? void 0 : login.role) === 'Customer' || (login === null || login === void 0 ? void 0 : login.role) === 'CustomerAdmin') && ((_a = applications.find(function (app) { return app.id == applicationId; })) === null || _a === void 0 ? void 0 : _a.name.toLowerCase()) === 'liberação de cursos' ?
                                _jsxs(_Fragment, { children: [_jsx(InputText, { onChange: formik.handleChange, name: 'courseName', label: 'Nome do Curso', inicialValue: formik.values.courseName, maxLength: 100 }, void 0), formik.errors.courseName && formik.touched.courseName && _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.courseName }), void 0)] }, void 0)
                                :
                                    formik.values.courseName = '', _jsx(InputText, { onChange: formik.handleChange, name: 'anyDeskAddress', label: 'End. AnyDesk', inicialValue: formik.values.anyDeskAddress, maxLength: 20 }, void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: 'w-1/5' }, { children: _jsx("div", __assign({ className: 'mt-6' }, { children: _jsx(Uploader, { setHasImg: setHasImg, stateOfFilesTochange: setPhotos, file: photos.uploadedFiles }, void 0) }), void 0) }), void 0), _jsx(InputTextBox, { onChange: formik.handleChange, value: formik.values.specification, width: '64%', name: 'specification', label: 'Descrição' }, void 0), formik.errors.specification && formik.touched.specification && _jsxs(_Fragment, { children: [" ", _jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.specification }), void 0), " ", _jsx("br", {}, void 0), " ", _jsx("br", {}, void 0)] }, void 0), _jsxs("div", __assign({ className: styles.buttons }, { children: [isSubmitting ?
                            _jsx(_Fragment, { children: _jsx("span", __assign({ className: styles.spanFakeButton }, { children: "Enviando..." }), void 0) }, void 0)
                            :
                                _jsx(_Fragment, { children: _jsx(Button, __assign({ type: 'submit', className: styles.submit, isButtonDisabled: desableted }, { children: "Enviar" }), void 0) }, void 0), _jsx(Button, __assign({ onClick: function () { return history.goBack(); }, type: 'button' }, { children: "Voltar" }), void 0)] }), void 0), errorMessage !== '' &&
                    _jsxs(_Fragment, { children: [_jsx("br", {}, void 0), _jsx("div", __assign({ className: styles.error }, { children: _jsxs(Alert, { children: [_jsx("strong", { children: "Aten\u00E7\u00E3o! " }, void 0), _jsx("span", { dangerouslySetInnerHTML: { __html: errorMessage } }, void 0)] }, void 0) }), void 0)] }, void 0)] }), void 0) }), void 0)
    //</div>
    );
};
export default Create;
